export enum TypeOfInterest {
  GENERAL = 'general',
  PRODUCT = 'product',
}
